<template>
  <div class="booking-format-address">
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.notifyingCode')">
      <special-character-tip :texts="specialCharCheck.notifyShortCode">
        <cargo-input v-model="manifestInfo.notifyShortCode" :class="importDifferenceField.notifyShortCode ? 'red-border' : ''" :placeholder="(isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterTheEnterpriseCode') : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" label="+" class="label-right">
      <special-character-tip :texts="specialCharCheck.notifyEnterpriseCode">
        <cargo-input v-model="manifestInfo.notifyEnterpriseCode" :class="importDifferenceField.notifyEnterpriseCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="notifyEnterpriseName" :class="labelStyle" :label="$t('SeaExport.notifyingName')" prop="notifyEnterpriseName" :rules="[{ validator: validatorNotifyEnterpriseName, trigger: 'blur' }]">
      <special-character-tip :texts="specialCharCheck.notifyEnterpriseName">
        <cargo-input v-if="!showCombinedManifest" v-model="manifestInfo.notifyEnterpriseName" :class="importDifferenceField.notifyEnterpriseName ? 'red-border' : ''" :placeholder="addressTip" :auto-uppercase="true" :auto-half-word="true" :trim="(isSeaHouseChannel || isWseChannel || isRongeTong)" />
        <cargo-rich-textarea
          v-else
          v-model="manifestInfo.notifyEnterpriseName"
          no="notifyEnterpriseName"
          :text-chars="0"
          :warning-count="-1"
          wrap-symbol="n"
          auto-half-word
          auto-uppercase
          style="height: 70px;min-height: 70px ; width: 180px"
          :disabled="!isEditing"
          :class="importDifferenceField.notifyEnterpriseName ? 'red-border' : ''"
          :is-trim="(isSeaHouseChannel || isWseChannel || isRongeTong)"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.notifyingName'),manifestInfo.notifyEnterpriseName,val=>{manifestInfo.notifyEnterpriseName=val})"
        />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="notifyAddress" :class="labelStyle" :label="$t('SeaExport.notifyingDetailAddress')" prop="notifyAddress" :rules="[{ validator: validatorNotifyAddress, trigger: 'blur' }]">
      <special-character-tip :texts="specialCharCheck.notifyAddress">
        <cargo-input v-if="!showCombinedManifest" v-model="manifestInfo.notifyAddress" :class="importDifferenceField.notifyAddress ? 'red-border' : ''" :placeholder="addressTip2" :auto-uppercase="true" :auto-half-word="true" :trim="(isSeaHouseChannel || isWseChannel || isRongeTong)" />
        <cargo-rich-textarea
          v-else
          ref="cargoTextarea1"
          v-model="manifestInfo.notifyAddress"
          no="notifyAddress"
          :text-chars="0"
          :warning-count="-1"
          wrap-symbol="n"
          auto-half-word
          auto-uppercase
          style="height: 110px;width: 180px"
          :disabled="!isEditing"
          :is-trim="true"
          :class="importDifferenceField.notifyAddress ? 'red-border' : ''"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.notifyingDetailAddress'),manifestInfo.notifyAddress,val=>{manifestInfo.notifyAddress=val})"
        />
      </special-character-tip>
    </el-form-item>
    <el-form-item :class="manifestInfo.notifyContactsType === 0 ? labelStyle : 'mag'" label-width="0" class="auto-width" style="display: inline-block;">
      <div style="display: flex;">
        <el-select v-model="manifestInfo.notifyContactsType" :class="importDifferenceField.notifyContactsType ? 'require-select red-border' : 'require-select'" style="width:146px" @change="changeContactsType">
          <el-option :label="$t('SeaExport.notifyingPhone')" :value="0" />
          <el-option :label="$t('SeaExport.notifyingEmail')" :value="1" />
          <el-option :label="$t('SeaExport.notifyingRelexNumber')" :value="2" />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item ref="notifyPhone" :class="manifestInfo.notifyContactsType === 0 ? labelStyle : 'mag'" label-width="0" class="auto-width" prop="notifyContacts" :rules="[{ validator: validatorNotifyPhone, trigger: 'blur' }]" style="display: inline-block;">
      <special-character-tip :texts="specialCharCheck.notifyContacts">
        <el-tooltip :content="manifestInfo.notifyContactsType === 0 ?$t('CargoMsg.Cargo_pleaseEnterAPhoneNumber'):''" placement="bottom" effect="light">
          <cargo-input
            v-model="manifestInfo.notifyContacts"
            :auto-uppercase="true"
            :auto-half-word="true"
            style="width:174px;margin-left:4px;"
            :class="importDifferenceField.notifyContacts ? 'red-border' : ''"
            :placeholder="manifestInfo.notifyContactsType === 0 && (isSeaHouseChannel || isWseChannel || isRongeTong) && isEditing ? $t('CargoMsg.Cargo_pleaseEnterAPhoneNumber') : ''"
          />
        </el-tooltip>
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.cityName')">
      <special-character-tip :texts="specialCharCheck.notifyCityName">
        <cargo-input v-model="manifestInfo.notifyCityName" :class="importDifferenceField.notifyCityName ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.provinceCode')">
      <special-character-tip :texts="specialCharCheck.notifyProvinceCode">
        <cargo-input v-model="manifestInfo.notifyProvinceCode" :class="importDifferenceField.notifyProvinceCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.provinceName')">
      <special-character-tip :texts="specialCharCheck.notifyProvinceName">
        <cargo-input v-model="manifestInfo.notifyProvinceName" :class="importDifferenceField.notifyProvinceName ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.ZipCode')">
      <special-character-tip :texts="specialCharCheck.notifyZipCode">
        <cargo-input v-model="manifestInfo.notifyZipCode" :class="importDifferenceField.notifyZipCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <el-form-item ref="notifyCountryCode" :class="labelStyle" :label="$t('CargoMsg.Cargo_CountryRegionCode')" prop="notifyCountryCode" :rules="[{ validator: validatorNotifyCountryCode, trigger: 'change' }]">
      <el-tooltip :content="$t('CargoMsg.Cargo_pleaseSelectACountryCode')" placement="bottom" effect="light">
        <special-character-tip :texts="specialCharCheck.notifyCountryCode">
          <cargo-input v-if="!isSeaHouseChannel && !isWseChannel && !isRongeTong" v-model="manifestInfo.notifyCountryCode" :class="importDifferenceField.notifyCountryCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
          <cargo-advance-select
            v-else
            :static-options="countryList || []"
            :cache="false"
            :default-value="manifestInfo.notifyCountryCode"
            filterable
            clearable
            :filter-tag-names="['name', 'code', 'chineseName']"
            :custom-label="(item)=>`[${item.code}]${item.name}`"
            tag-name="name"
            tag-value="code"
            :class="importDifferenceField.notifyCountryCode ? 'red-border' : ''"
            :placeholder="$t('CargoMsg.Cargo_pleaseSelectACountryCode')"
            @parentCallBack="p=>{manifestInfo.notifyCountryCode=p.value}"
          />
        </special-character-tip>
      </el-tooltip>
    </el-form-item>
    <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('SeaExport.aeoEnterpriseCode')">
      <special-character-tip :texts="specialCharCheck.notifyAeoEnterpriseCode">
        <cargo-input v-model="manifestInfo.notifyAeoEnterpriseCode" :class="importDifferenceField.notifyAeoEnterpriseCode ? 'red-border' : ''" :auto-uppercase="true" :auto-half-word="true" />
      </special-character-tip>
    </el-form-item>
    <div style="display: flex; justify-content: center; align-items: center;">
      <el-button
        v-show="!notSeaHouseChannelOrWseChannel"
        style="margin-left: 5px;height: 28px;"
        type="primary"
        @click="copyRecipient"
      >{{ $t('CargoMsg.Cargo_CopyRecipient') }}</el-button>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="!isEditing"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <button
          v-show="isEditing"
          class="el-button el-button--default el-button--mini"
          no="advanceTextDialogConfirm"
          type="button"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</button>
        <button
          no="advanceTextDialogClose"
          type="button"
          class="el-button el-button--default el-button--mini"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import { TabError } from '@/utils/class/TabError'
import StrUtils from '@/utils/StrUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'

export default {
  name: 'BookingNotifyFormatAddress',
  components: { cargoRichTextarea, CargoAdvanceSelect, cargoInput, specialCharacterTip },
  props: {
    manifestInfo: { type: Object, required: true },
    isSeaHouseChannel: { type: Boolean, default: false },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false },
    countryList: { type: Array, default: () => [] },
    job: { type: Object, default: () => {} },
    showCombinedManifest: { type: Boolean, default: false }
  },
  data() {
    var validatorNotifyEnterpriseName = (rule, value, callback) => {
      if (this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) {
        if (!(this.manifestInfo.notifyEnterpriseName.length > 0 && this.manifestInfo.notifyEnterpriseName.length <= 70)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperEnterpriseNameTip2')))
        }
      }
    }
    var validatorNotifyAddress = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!(this.manifestInfo.notifyAddress.length > 0 && this.manifestInfo.notifyAddress.length <= 140)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperEnterpriseNameTip')))
        }
      }
    }
    var validatorNotifyPhone = (rule, value, callback) => {
      if (this.isSeaHouseChannel && this.manifestInfo.notifyContactsType === 0) {
        if (!this.manifestInfo.notifyContacts.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperContactsTip')))
        }
      }
      if ((this.isWseChannel || this.isRongeTong) && this.manifestInfo.notifyContactsType === 0) {
        if (!(this.manifestInfo.notifyContacts.length > 0 && this.manifestInfo.notifyContacts.length <= 20)) {
          return callback(new Error(this.$t('CargoMsg.Cargo_ShipperContactsTip')))
        }
      }
      return callback()
    }
    var validatorNotifyCountryCode = (rule, value, callback) => {
      if (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) {
        if (!this.manifestInfo.notifyCountryCode.length > 0) {
          return callback(new Error(this.$t('CargoMsg.Cargo_pleaseSelectACountryCode')))
        }
      }
    }
    return {
      validatorNotifyEnterpriseName,
      validatorNotifyAddress,
      validatorNotifyPhone,
      validatorNotifyCountryCode,
      specialCharCheck: {
        notifyShortCode: null,
        notifyEnterpriseCode: null,
        notifyEnterpriseName: null,
        notifyAddress: null,
        notifyContacts: null,
        notifyCityName: null,
        notifyProvinceCode: null,
        notifyProvinceName: null,
        notifyZipCode: null,
        notifyCountryCode: null,
        notifyAeoEnterpriseCode: null
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  computed: {
    labelStyle() {
      return (this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) ? 'required-label' : ''
    },
    notSeaHouseChannelOrWseChannel() {
      return !(this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong)
    },
    addressTip() {
      if ((this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong) && this.isEditing) {
        return this.$t('CargoMsg.Cargo_pleaseEnterANameWithin140Characters2')
      }
      return ''
    },
    addressTip2() {
      if ((this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong) && this.isEditing) {
        return this.$t('CargoMsg.Cargo_pleaseEnterANameWithin140Characters')
      }
      return ''
    },
    importDifferenceField() {
      if (this.job) {
        return this.job.differencePrePlanFields || {}
      }
      return {}
    }
  },
  watch: {
    manifestInfo: {
      immediate: true,
      handler() {
        if (this.specialCharacterCheck) {
          for (const key in this.specialCharCheck) {
            this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.manifestInfo[key])
          }
        } else {
          for (const key in this.specialCharCheck) {
            this.specialCharCheck[key] = null
          }
        }
      }
    },
    isSeaHouseChannel() {
      this.validate()
    },
    isWseChannel() {
      this.validate()
    },
    isRongeTong() {
      this.validate()
    }
  },
  methods: {
    changeContactsType() {
      this.$refs['notifyPhone'].clearValidate()
    },
    validate() {
      this.$refs['notifyEnterpriseName'].clearValidate()
      this.$refs['notifyAddress'].clearValidate()
      this.$refs['notifyPhone'].clearValidate()
      this.$refs['notifyCountryCode'].clearValidate()
    },
    checkModel(tabName) {
      const manifestInfo = this.manifestInfo
      if (manifestInfo.instructBill) {
        if (!manifestInfo.notifyEnterpriseCode) {
          throw new TabError(this.$t('SeaExport.NotifierCodeCannotBeEmpty'), tabName)
        }
        if (!manifestInfo.notifyContacts) {
          throw new TabError(this.$t('SeaExport.ContactNotifierCannotBeBlank'), tabName)
        }
      }
    },
    copyRecipient() {
      this.manifestInfo.notifyEnterpriseName = this.manifestInfo.consigneeEnterpriseName
      this.manifestInfo.notifyAddress = this.manifestInfo.consigneeAddress
      this.manifestInfo.notifyContactsType = this.manifestInfo.consigneeContactsType
      this.manifestInfo.notifyContacts = this.manifestInfo.consigneeContacts
      this.manifestInfo.notifyCountryCode = this.manifestInfo.consigneeCountryCode
      this.validate()
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0,
        autoHalfWord: false,
        autoUppercase: false
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    closeAdvanceText() {
      this.advanceTextDialog.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .booking-format-address{
    /deep/ .required-label {
      .el-form-item__label {
        color: #1F75D5 !important;
      }
      .require-select input{
        color: #1F75D5 !important;
      }
    }
  }
  /deep/ .el-form-item {
    margin-bottom: 20px !important; /* 设置上下间距 */
  }
  /deep/ .el-form-item.mag {
    margin-bottom: 20px !important; /* 设置上下间距 */
  }

  .red-border {
    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
      border: 1px solid red !important;
    }
  }
</style>
